const FilterIcon = ({ width = 16, height = 16, fill, ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}
  >
    <path
      d="M14.0013 12V14H12.668V12H11.3346V10.6667H15.3346V12H14.0013ZM3.33464 12V14H2.0013V12H0.667969V10.6667H4.66797V12H3.33464ZM7.33464 4V2H8.66797V4H10.0013V5.33333H6.0013V4H7.33464ZM7.33464 6.66667H8.66797V14H7.33464V6.66667ZM2.0013 9.33333V2H3.33464V9.33333H2.0013ZM12.668 9.33333V2H14.0013V9.33333H12.668Z"
      fill={fill || "currentColor"}
    />
  </svg>
);

export default FilterIcon;
